import React from "react"
import weekend1 from '../assets/images/weekend1.png'
import weekend2 from '../assets/images/weekend2.png'
import both from '../assets/images/bothWeekends.png'

const Image = ({ option }) => {

  if (option === '1') {
    return (
        <div className="hidden col-span-6 col-end-13 row-start-1 md:block">
          <div className="mt-10">
            <img src={weekend1} alt="option-1"/>
          </div>
        </div>
      )
  }

  if (option === '2') {
    return (
        <div className="hidden col-span-6 col-end-13 row-start-1 md:block">
          <div className="mt-10">
            <img src={weekend2} alt="option-2"/>
          </div>
        </div>
      )
  }

  return (
    <div className="hidden col-span-6 col-end-13 row-start-1 md:block">
      <div className="mt-10">
        <img src={both} alt="option-3"/>
      </div>
    </div>
    )
}

export default Image